module.exports = __webpack_public_path__ + "img/q_27_sor.00795638.png";